// ---------------------------------------------------------------------------
// App «Documentación» (CC-CONSOLE #1632) — identidad y secciones SIN React ni
// pantallas, para que el AppsSidebar y las pruebas de paridad no arrastren los
// módulos de las secciones (y con ellos Firebase). `config.tsx` arma el MENU con
// sus elementos a partir de estos ids; `sections.test.tsx` comprueba que sean
// los mismos.
// ---------------------------------------------------------------------------

export const DOCUMENTACION_BASE = "/documentacion";
export const DOCUMENTACION_APP_ID = "documentacion";
export const DOCUMENTACION_CATEGORY_ID = "freight-forwarding";

export interface DocumentacionSection {
  id: string; // segmento de ruta bajo /documentacion = id del menú del preset y del catálogo
  labelKey: string; // clave i18n del namespace `documentacion`
  icon: string; // remixicon
}

export const SECTIONS: readonly DocumentacionSection[] = [
  { id: "resumen", labelKey: "menu.resumen", icon: "ri-dashboard-3-line" },
  { id: "expedientes", labelKey: "menu.expedientes", icon: "ri-folder-open-line" },
  { id: "repositorio", labelKey: "menu.repositorio", icon: "ri-archive-drawer-line" },
  { id: "plantillas", labelKey: "menu.plantillas", icon: "ri-list-settings-line" },
  { id: "vencimientos", labelKey: "menu.vencimientos", icon: "ri-calendar-close-line" },
];

/** Ruta inicial (resumen). */
export const documentacionDefaultRoute = `${DOCUMENTACION_BASE}/${SECTIONS[0].id}`;

/** Ruta del expediente de un sujeto dentro de la app (`?subject=kind:id`, aparte de los filtros `kind`/`state`). */
export const documentacionSubjectRoute = (kind: "shipment" | "booking", id: string) => `${DOCUMENTACION_BASE}/expedientes?subject=${encodeURIComponent(`${kind}:${id}`)}`;

/** `kind:id` → referencia del sujeto, o null si no es válida. */
export function parseSubjectParam(value: string | null): { kind: "shipment" | "booking"; id: string } | null {
  if (!value) return null;
  const idx = value.indexOf(":");
  if (idx <= 0) return null;
  const kind = value.slice(0, idx);
  const id = value.slice(idx + 1);
  if ((kind !== "shipment" && kind !== "booking") || !id) return null;
  return { kind, id };
}

/** Metadatos del mosaico del AppsSidebar. */
export const documentacionApp = {
  id: DOCUMENTACION_APP_ID,
  iconClass: "ri-folder-shield-2-line",
  color: "bg-cyan-600",
  route: documentacionDefaultRoute,
};
